import { Link } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import { Reveal, Stagger, StaggerItem } from "../components/Reveal";
import { PROCESS } from "../data/content";

export default function Process() {
  return (
    <>
      <PageHeader
        testid="process-page-header"
        overline="Design Process"
        title={["From first sketch", "to final styling."]}
        intro="Five disciplined stages. One project manager. Weekly photo-reports and a live cost sheet — so the only surprise is how well it fits."
      />

      <section className="container-lux pb-24" data-testid="process-timeline">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="hidden lg:block lg:col-span-4">
            <div className="sticky top-32">
              <p className="font-serif font-light text-4xl leading-snug text-ink">
                A process built for <span className="italic text-bronze">calm.</span>
              </p>
              <p className="mt-5 text-[15px] font-light leading-relaxed text-stone-warm">
                Most interior projects strain at the same three points — budgets
                that drift, sites that stall, decisions made in haste. Ours is
                sequenced so each stage closes before the next begins.
              </p>
              <Link to="/contact" data-testid="process-cta" className="btn-bronze mt-9">
                Start Stage One
              </Link>
            </div>
          </div>

          <Stagger className="lg:col-span-8">
            {PROCESS.map((p) => (
              <StaggerItem key={p.num}>
                <div
                  data-testid={`process-stage-${p.num}`}
                  className="grid gap-6 border-t border-bronze/20 py-10 sm:grid-cols-12 sm:gap-8"
                >
                  <div className="sm:col-span-3">
                    <p className="font-serif text-6xl text-gold/40 leading-none">{p.num}</p>
                    <p className="mt-3 inline-block border border-bronze/25 px-3 py-1 text-[11px] font-mono uppercase tracking-[0.18em] text-bronze">
                      {p.duration}
                    </p>
                  </div>
                  <div className="sm:col-span-9">
                    <h2 className="font-serif font-light text-3xl text-ink">{p.title}</h2>
                    <p className="mt-4 max-w-xl text-[15px] font-light leading-relaxed text-stone-warm">
                      {p.desc}
                    </p>
                    <div className="mt-6 flex flex-wrap gap-2.5">
                      {p.deliverables.map((d) => (
                        <span
                          key={d}
                          className="bg-sand border border-bronze/10 px-3.5 py-1.5 text-[12px] text-ink/70"
                        >
                          {d}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>
    </>
  );
}
